package pl.decks.personal.components.layouts.site

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaAt
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun SiteLogo() = Row(
    modifier = SiteLayoutStylesheet.Header.Logo.toModifier(),
    verticalAlignment = Alignment.CenterVertically,
) {
    Image("favicon.svg", modifier = Modifier.objectFit(ObjectFit.Contain))
    SpanText("pi")
    FaAt(modifier = SiteLayoutStylesheet.Header.LogoIcon.toModifier())
    SpanText("blaze")
}
